import React, { useEffect, useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { getGroups } from '../../../store/groups/actions';

export default function ComposeSelectGroups({ show, onClose, handleAddGroups, selectedItem }) {
    const dispatch = useDispatch();
    const { groupList } = useSelector(state => state.grouplists);
    const [selectedGroups, setSelectedGroups] = useState([]);
    const [errorMessage, setErrorMessage] = useState(null);

    useEffect(() => {
        dispatch(getGroups({ sort: 2 }));
    }, []);

    useEffect(() => {
        if (selectedItem !== null) {
            setSelectedGroups(selectedItem);
        }        
    }, [selectedItem]);


    const handleGroupToggle = (e, group) => {
        const checked = e.target.checked;
        const updatedOrganization = checked
            ? [...selectedGroups, group]
            : selectedGroups.filter(item => item.id !== group.id);
        setSelectedGroups(updatedOrganization);
    }

    const handleOnClose = () => {
        onClose(); // Close the modal
        setErrorMessage(null);
    };

    const handleKeyDown = useCallback((event) => {
        if (event.key === 'Escape') {
            handleOnClose();
        }
    }, [handleOnClose]);

    useEffect(() => {
        if (show) {
            document.addEventListener('keydown', handleKeyDown);
        } else {
            document.removeEventListener('keydown', handleKeyDown);
        }

        return () => {
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, [show, handleKeyDown]);



    if (!show) {
        return null;
    }

    return (
        <div className="admin-modal-overlay select-group-modal">
            <div className="admin-modal admin-add-role modal-header-border">
                <button className="admin-modal-close modal-close" onClick={handleOnClose}>
                    <span className="material-symbols-rounded">close</span>
                </button>
                <h2 className="admin-modal-heading heading-align-right">Select Group(s)</h2>
                <div className="admin-modal-scroll">
                    
                    <div className="admin-modal-row">
                        <div className="admin-modal-cell">
                            <label className="admin-default-label" htmlFor="appointment-time-range">
                                Select Group(s)
                            </label>
                            <div className="admin-column-wrap auto-columns">
                                {groupList.filter(item => item.recordCount > 0).map(item => (
                                    <label className="admin-checkbox-label inline inline-width-50" key={item.id}>
                                        <input
                                            className="admin-inline-checkbox"
                                            type="checkbox"
                                            checked={selectedGroups && selectedGroups.some(x => x.id === item.id)}
                                            onChange={(e) => {
                                                handleGroupToggle(e, item);
                                                setErrorMessage(null);
                                            }}
                                        />
                                        {item?.name} ({item?.recordCount})                                        
                                    </label>
                                ))}                                
                            </div>
                        </div>
                    </div>                  
                    <div className="admin-modal-button-wrap">
                        {errorMessage && <p className="error-messagess">{errorMessage}</p>}
                        <button className="admin-modal-button power" onClick={() => {
                            if (!selectedGroups || selectedGroups.length === 0) {
                                setErrorMessage('Please select group(s).');
                                return false;
                            }

                            handleAddGroups(selectedGroups);
                        }}>
                            Add Group(s)
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}


ComposeSelectGroups.propTypes = {
    show: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    handleAddGroups: PropTypes.func.isRequired,
    selectedItem: PropTypes.arrayOf(PropTypes.any)
};